import { cn } from '@module/lib/utils';
import type { ChangeEvent, HTMLProps } from 'react';

interface Props extends HTMLProps<HTMLInputElement> {
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  bgClassName?: string;
  buttonSize?: 'sm' | 'md';
}

function SwitchButton({ checked, bgClassName, onChange, buttonSize = 'sm', className, ...props }: Props) {
  return (
    <label
      className={cn(
        'flex cursor-pointer items-center',
        {
          'opacity-50': props.disabled,
        },
        bgClassName,
      )}
    >
      <div className='relative'>
        <input
          type='checkbox'
          className={cn('sr-only', className)} // 스크린 리더만을 위한 숨김 처리
          checked={checked}
          onChange={(e) => onChange?.(e)}
          {...props}
        />
        <div
          className={cn('block h-[20px] w-[34px] rounded-full', {
            'bg-primaryFg': checked,
            'bg-colorBg_cek1': !checked,
            'h-[24px] w-[40px]': buttonSize === 'md',
          })}
        />
        <div
          className={cn(
            `dot absolute top-[1px] left-[2px] h-[18px] w-[18px] rounded-full bg-white shadow-lg transition-transform`,
            {
              'translate-x-[12px] transform': checked,
              'translate-x-[14px] transform': buttonSize === 'md' && checked,
              'top-[1px] left-[2px] h-[22px] w-[22px]': buttonSize === 'md',
            },
          )}
        />
      </div>
    </label>
  );
}

export default SwitchButton;
